import { useEffect, useRef } from 'react';
import { trackEvent } from '../services/analytics';

function Story() {
  const sectionRef = useRef(null);
  useEffect(() => {
    const node = sectionRef.current;
    if (!node || !('IntersectionObserver' in window)) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { trackEvent('story_viewed'); observer.disconnect(); }
    }, { threshold: 0.35 });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="story section" id="story" aria-labelledby="story-title" ref={sectionRef}>
      <div className="story__image-wrap">
        <img
          src="/story-parade-v3-1120.jpg"
          srcSet="/story-parade-v3-720.jpg 720w, /story-parade-v3-1120.jpg 1120w"
          sizes="(max-width: 620px) calc(100vw - 58px), 42vw"
          width="1120"
          height="1399"
          loading="lazy"
          alt="Friends and three dogs rolling an enormous roast turkey through an autumn parade"
        />
        <span className="story__stamp" aria-hidden="true">EST. 2003-ish</span>
      </div>
      <div className="story__copy">
        <p className="eyebrow">A very big origin story</p>
        <h2 id="story-title">It started with a 26-pound turkey</h2>
        <p>It was a regular mid-November grocery run. Thanksgiving food was everywhere, and in the middle of the frozen turkeys sat one colossal bird, dwarfing every respectable turkey around it. It felt like a standout in a world of average. Naturally, I bought it.</p>
        <p>At home, the obvious problem arrived: how do two people handle a 26-pound turkey? The roasting guide stopped at 25 pounds, which seemed both unhelpful and a little judgmental. The only sensible answer was to invite a crowd. Friends brought their favorite dishes, we took charge of the oversized centerpiece, and nearly five hours later dinner was ready.</p>
        <blockquote>“The turkey was too big for dinner, so we made the dinner big enough for the turkey.”</blockquote>
        <p>Everyone wanted to know why this particular feast existed. The story made its way around the room, and by the end of the night it had a name: Brent Bought a Big Damn Turkey. When friends started asking about the next one, an improvised potluck became a tradition. It has weathered busy years, strange years, and even the pandemic—and it keeps bringing good people back to the table.</p>
        <p className="story__tag">#BBABDT</p>
      </div>
    </section>
  );
}

export default Story;
